// This file is autogenerated!
// Do not edit manually!
// All changes will be overwritten by package-sync.ts
/* istanbul ignore file */

export enum PackageName {
  ChromecastReceiver = 'chromecast-receiver',
Ui = 'ui',
QaApp = 'qa-app',
RtlPlusUi = 'rtl-plus-ui',
AdPlayerBitmovin = 'ad-player-bitmovin',
AdPlayerNative = 'ad-player-native',
Builder = 'builder',
CommonBitmovinAnalytics = 'common-bitmovin-analytics',
CommonNpawAnalytics = 'common-npaw-analytics',
Es5 = 'es5',
FetchService = 'fetch-service',
Loader = 'loader',
Logger = 'logger',
PlatformCheck = 'platform-check',
PlayerContainerChromecast = 'player-container-chromecast',
PlayerContainerDom = 'player-container-dom',
PlayerBitmovin = 'player-bitmovin',
PlayerChromecast = 'player-chromecast',
Core = 'core',
PlayerDashjs = 'player-dashjs',
PlayerNative = 'player-native',
PluginAdvertising = 'plugin-advertising',
PluginBitmovinAnalyticsBitmovin = 'plugin-bitmovin-analytics-bitmovin',
PluginBitmovinAnalyticsDashjs = 'plugin-bitmovin-analytics-dashjs',
PluginConcurrentStreamCheck = 'plugin-concurrent-stream-check',
PluginDeviceHeader = 'plugin-device-header',
PluginEntitlement = 'plugin-entitlement',
PluginGoogleAnalytics4 = 'plugin-google-analytics-4',
PluginHeartbeat = 'plugin-heartbeat',
PluginMediaSession = 'plugin-media-session',
PluginNielsen = 'plugin-nielsen',
PluginNpawAnalyticsBitmovin = 'plugin-npaw-analytics-bitmovin',
PluginNpawAnalyticsChromecast = 'plugin-npaw-analytics-chromecast',
PluginNpawAnalyticsDashjs = 'plugin-npaw-analytics-dashjs',
PluginNpawAnalyticsNative = 'plugin-npaw-analytics-native',
PluginOnScreenLog = 'plugin-on-screen-log',
PluginRcuBindings = 'plugin-rcu-bindings',
PluginSsai = 'plugin-ssai',
PluginStreamFallback = 'plugin-stream-fallback',
PluginVisibility = 'plugin-visibility',
PolyfillsEs5 = 'polyfills-es5',
PolyfillsEs6 = 'polyfills-es6',
Polyfills = 'polyfills',
Runtime = 'runtime',
Storage = 'storage',
Types = 'types',
Utils = 'utils',
};

export const PACKAGE_NAME_TO_GLOBAL_NAME = {
  [PackageName.ChromecastReceiver]: 'foundation.chromecastReceiver',
[PackageName.Ui]: 'foundation.ui',
[PackageName.QaApp]: 'foundation.qaApp',
[PackageName.RtlPlusUi]: 'foundation.rtlPlusUi',
[PackageName.AdPlayerBitmovin]: 'foundation.adPlayer.bitmovin',
[PackageName.AdPlayerNative]: 'foundation.adPlayer.native',
[PackageName.Builder]: 'foundation.builder',
[PackageName.CommonBitmovinAnalytics]: 'foundation.common.bitmovinAnalytics',
[PackageName.CommonNpawAnalytics]: 'foundation.common.npawAnalytics',
[PackageName.Es5]: 'foundation.es5',
[PackageName.FetchService]: 'foundation.fetchService',
[PackageName.Loader]: 'foundation.loader',
[PackageName.Logger]: 'foundation.logger',
[PackageName.PlatformCheck]: 'foundation.platformCheck',
[PackageName.PlayerContainerChromecast]: 'foundation.playerContainer.chromecast',
[PackageName.PlayerContainerDom]: 'foundation.playerContainer.dom',
[PackageName.PlayerBitmovin]: 'foundation.player.bitmovin',
[PackageName.PlayerChromecast]: 'foundation.player.chromecast',
[PackageName.Core]: 'foundation.player.core',
[PackageName.PlayerDashjs]: 'foundation.player.dashjs',
[PackageName.PlayerNative]: 'foundation.player.native',
[PackageName.PluginAdvertising]: 'foundation.plugin.advertising',
[PackageName.PluginBitmovinAnalyticsBitmovin]: 'foundation.plugin.bitmovinAnalytics',
[PackageName.PluginBitmovinAnalyticsDashjs]: 'foundation.plugin.bitmovinAnalytics',
[PackageName.PluginConcurrentStreamCheck]: 'foundation.plugin.concurrentStreamCheck',
[PackageName.PluginDeviceHeader]: 'foundation.plugin.deviceHeader',
[PackageName.PluginEntitlement]: 'foundation.plugin.entitlement',
[PackageName.PluginGoogleAnalytics4]: 'foundation.plugin.googleAnalytics4',
[PackageName.PluginHeartbeat]: 'foundation.plugin.heartbeat',
[PackageName.PluginMediaSession]: 'foundation.plugin.mediaSession',
[PackageName.PluginNielsen]: 'foundation.plugin.nielsen',
[PackageName.PluginNpawAnalyticsBitmovin]: 'foundation.plugin.npawAnalytics',
[PackageName.PluginNpawAnalyticsChromecast]: 'foundation.plugin.npawAnalytics',
[PackageName.PluginNpawAnalyticsDashjs]: 'foundation.plugin.npawAnalytics',
[PackageName.PluginNpawAnalyticsNative]: 'foundation.plugin.npawAnalytics',
[PackageName.PluginOnScreenLog]: 'foundation.plugin.onScreenLog',
[PackageName.PluginRcuBindings]: 'foundation.plugin.rcuBindings',
[PackageName.PluginSsai]: 'foundation.plugin.ssai',
[PackageName.PluginStreamFallback]: 'foundation.plugin.streamFallback',
[PackageName.PluginVisibility]: 'foundation.plugin.visibility',
[PackageName.PolyfillsEs5]: 'foundation.polyfill.es5',
[PackageName.PolyfillsEs6]: 'foundation.polyfill.es6',
[PackageName.Polyfills]: 'foundation.polyfills',
[PackageName.Runtime]: 'foundation.runtime',
[PackageName.Storage]: 'foundation.storage',
[PackageName.Types]: 'foundation.types',
[PackageName.Utils]: 'foundation.utils',
} as const;

export const PACKAGE_NAME_TO_BUNDLE_NAME = {
  [PackageName.ChromecastReceiver]: 'foundation.chromecastReceiver',
[PackageName.Ui]: 'foundation.ui',
[PackageName.QaApp]: 'foundation.qaApp',
[PackageName.RtlPlusUi]: 'foundation.rtlPlusUi',
[PackageName.AdPlayerBitmovin]: 'foundation.adPlayer.bitmovin',
[PackageName.AdPlayerNative]: 'foundation.adPlayer.native',
[PackageName.Builder]: 'foundation.builder',
[PackageName.CommonBitmovinAnalytics]: 'foundation.common.bitmovinAnalytics',
[PackageName.CommonNpawAnalytics]: 'foundation.common.npawAnalytics',
[PackageName.Es5]: 'foundation.es5',
[PackageName.FetchService]: 'foundation.fetchService',
[PackageName.Loader]: 'foundation.loader',
[PackageName.Logger]: 'foundation.logger.bundle',
[PackageName.PlatformCheck]: 'foundation.platformCheck.bundle',
[PackageName.PlayerContainerChromecast]: 'foundation.playerContainer.chromecast',
[PackageName.PlayerContainerDom]: 'foundation.playerContainer.dom',
[PackageName.PlayerBitmovin]: 'foundation.player.bitmovin',
[PackageName.PlayerChromecast]: 'foundation.player.chromecast',
[PackageName.Core]: 'foundation.player.core',
[PackageName.PlayerDashjs]: 'foundation.player.dashjs',
[PackageName.PlayerNative]: 'foundation.player.native',
[PackageName.PluginAdvertising]: 'foundation.plugin.advertising',
[PackageName.PluginBitmovinAnalyticsBitmovin]: 'foundation.plugin.bitmovinAnalytics.bitmovin',
[PackageName.PluginBitmovinAnalyticsDashjs]: 'foundation.plugin.bitmovinAnalytics.dashjs',
[PackageName.PluginConcurrentStreamCheck]: 'foundation.plugin.concurrentStreamCheck',
[PackageName.PluginDeviceHeader]: 'foundation.plugin.deviceHeader',
[PackageName.PluginEntitlement]: 'foundation.plugin.entitlement',
[PackageName.PluginGoogleAnalytics4]: 'foundation.plugin.googleAnalytics4',
[PackageName.PluginHeartbeat]: 'foundation.plugin.heartbeat',
[PackageName.PluginMediaSession]: 'foundation.plugin.mediaSession',
[PackageName.PluginNielsen]: 'foundation.plugin.nielsen',
[PackageName.PluginNpawAnalyticsBitmovin]: 'foundation.plugin.npawAnalytics.bitmovin',
[PackageName.PluginNpawAnalyticsChromecast]: 'foundation.plugin.npawAnalytics.chromecast',
[PackageName.PluginNpawAnalyticsDashjs]: 'foundation.plugin.npawAnalytics.dashjs',
[PackageName.PluginNpawAnalyticsNative]: 'foundation.plugin.npawAnalytics.native',
[PackageName.PluginOnScreenLog]: 'foundation.plugin.onScreenLog',
[PackageName.PluginRcuBindings]: 'foundation.plugin.rcuBindings',
[PackageName.PluginSsai]: 'foundation.plugin.ssai',
[PackageName.PluginStreamFallback]: 'foundation.plugin.streamFallback',
[PackageName.PluginVisibility]: 'foundation.plugin.visibility',
[PackageName.PolyfillsEs5]: 'foundation.polyfill.es5',
[PackageName.PolyfillsEs6]: 'foundation.polyfill.es6',
[PackageName.Polyfills]: 'foundation.polyfills',
[PackageName.Runtime]: 'foundation.runtime',
[PackageName.Storage]: 'foundation.storage',
[PackageName.Types]: 'foundation.types',
[PackageName.Utils]: 'foundation.utils',
} as const;
